import { accountEntityName } from '../../../../../../backend/features/accounts/shared';
import { groupEntityName } from '../../../../../../backend/features/groups/shared';
import { requireAnySystemPermission } from '../../../../../../backend/features/permissions/shared';
import { AppPaper } from '../../../../../../ui/components/deprecated/AppPaper';
import { GroupMembers } from '../../../../../../ui/features/groups/components/GroupsPanel/components/GroupMembers';
import { useGroupAuditBackendDataProvider } from '../../../../../../ui/features/groups/hooks/useGroupAuditBackendDataProvider';
import { useUserState } from '../../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { Form } from '@juvare/common-form-ui/Form';
import { AppPageHeader2 } from '@juvare/common-web-ui/AppPageHeader2';
import { FullHeightPage } from '@juvare/common-web-ui/FullHeightPage';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { PageError } from '@juvare/common-web-ui/PageError';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { EntityAudit } from '@juvare/platform-sdk-react/ui/features/audit';
import { useStorageClient, useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useGroup } from '../../../hooks/useGroup';
import { useGroupSection } from '../../../hooks/useGroupSection';
import { useGroupSectionsNew } from '../../../hooks/useGroupSectionsNew';
export const GroupSectionPage = ({ customMemberSlideoutMenuItems, customMemberDetailsComponent }) => {
    const { t } = useContactManagementTranslation();
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { groupId, sectionNameLowerCase } = useParams();
    const groupResponse = useGroup(groupId);
    const sectionsResponse = useGroupSectionsNew();
    const group = groupResponse.data;
    const sections = sectionsResponse.data;
    const isLoading = groupResponse.isLoading || sectionsResponse.isLoading;
    const error = groupResponse.error || sectionsResponse.error;
    const handleReloadGroup = groupResponse.mutate;
    const formatters = {
        'criteria.filters\\.\\d+\\.value\\.\\d+': (key, oldValue, newValue, auditRecord) => {
            const entityAuditMapping = auditRecord.params && 'entityAuditMapping' in auditRecord.params ? auditRecord.params.entityAuditMapping : undefined;
            const result = {};
            if (!entityAuditMapping) {
                return { key, oldValue, newValue };
            }
            if (typeof oldValue === 'string') {
                const splitedOldValue = oldValue.split('_');
                if (splitedOldValue.length === 2) {
                    result.oldValue = `${entityAuditMapping[splitedOldValue[0]]}_${splitedOldValue[1]}`;
                }
                else {
                    result.oldValue = oldValue;
                }
            }
            if (typeof newValue === 'string') {
                const splitedNewValue = newValue.split('_');
                if (splitedNewValue.length === 2) {
                    result.newValue = `${entityAuditMapping[splitedNewValue[0]]}_${splitedNewValue[1]}`;
                }
                else {
                    result.newValue = newValue;
                }
            }
            return result;
        },
    };
    if (groupId && group && sections && !error) {
        let subTitle = '';
        let sectionDetails = null;
        if (sectionNameLowerCase === 'history') {
            subTitle = t('panels.groups.history');
            sectionDetails = (React.createElement(Box, { sx: { p: 2 } },
                React.createElement(EntityAudit, { entitiesList: [{ entity: groupEntityName, entityIds: [groupId] }], customAuditBackendDataProvider: useGroupAuditBackendDataProvider, formatters: formatters })));
        }
        else {
            const section = sections.rows.find((row) => row.columns.name.toLowerCase() === sectionNameLowerCase);
            if (!section) {
                return React.createElement(PageError, { type: 'not-found' });
            }
            subTitle = section.columns.title;
            if (section.columns.key === 'members') {
                sectionDetails = (React.createElement(AppPaper, null,
                    React.createElement(GroupMembers, { group: group, onReloadGroup: handleReloadGroup, customMemberSlideoutMenuItems: customMemberSlideoutMenuItems, customMemberDetailsComponent: customMemberDetailsComponent })));
            }
            else {
                sectionDetails = (React.createElement(AppPaper, { contentPadding: 2, contentWidth: 800 },
                    React.createElement(SectionDetails, { group: group, sectionId: section.id })));
            }
        }
        return (React.createElement(FullHeightPage, { scrollable: true },
            React.createElement(AppPageHeader2, { title: t('panels.groups.title'), subTitle: [group.data.name, subTitle], onBack: () => navigationContext.navigate(() => { var _a; return (((_a = location.state) === null || _a === void 0 ? void 0 : _a.back) ? navigate(-1) : navigate('..')); }) }),
            sectionDetails));
    }
    else if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    else {
        return React.createElement(PageError, { error: error });
    }
};
const SectionDetails = ({ group, sectionId }) => {
    const { t } = useContactManagementTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const userState = useUserState();
    const storageClient = useStorageClient(groupEntityName);
    const sectionResponse = useGroupSection(sectionId);
    const ownerId = requireAnySystemPermission(userState, 'all-organizations-admin', 'manage-groups') ? group.createdBy : undefined;
    const ownerResponse = useOwnerDisplayName(ownerId);
    const section = sectionResponse.data;
    const owner = ownerResponse === null || ownerResponse === void 0 ? void 0 : ownerResponse.data;
    const isLoading = sectionResponse.isLoading || (ownerResponse === null || ownerResponse === void 0 ? void 0 : ownerResponse.isLoading);
    const error = sectionResponse.error || (ownerResponse === null || ownerResponse === void 0 ? void 0 : ownerResponse.error);
    if (section && !error) {
        const formParams = {
            id: group.id,
            createdBy: group.createdBy,
            ownerDisplayName: owner,
        };
        return (React.createElement(Form, { config: section.data.form, data: group.data, formParams: formParams, key: owner, trackChanges: 'ask-to-save', onSubmit: (data) => {
                return storageClient.post({
                    action: 'partial-update',
                    id: group.id,
                    data: data,
                });
            }, onSubmitSuccess: () => {
                var _a;
                showInfoSnackbar({ message: t('common.saved'), autoHideDuration: 2000 });
                if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.back) {
                    navigate(-1);
                }
                else {
                    navigate({
                        pathname: '..',
                        search: new URLSearchParams({ id: group.id }).toString(),
                    }, {});
                }
            } }));
    }
    else if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    else {
        return React.createElement(PageError, { error: error });
    }
};
function useOwnerDisplayName(accountId) {
    var _a, _b, _c;
    const response = useStorageList(accountEntityName, {
        filter: [
            {
                op: 'in',
                id: accountId ? [accountId] : [],
            },
        ],
    });
    return Object.assign(Object.assign({}, response), { data: (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.rows) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.columns.displayName });
}
